import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import styles from "./Header.module.css";
import addPhoto from "../images/addPhoto.png";
import addScore from "../images/addScore.png";
import ChallengeModal from "./Modals/ChallengeModal/ChallengeModal";
import IsAuth from "../../createContext/is-Auth/IsAuthContext";
import { PostContext } from "../../createContext/Post/PostContext";
import ScoreModal from "./Modals/ScoreModal/ScoreModal";
import CreateReelBox from "../Profile/Components/CreateReelBox";

function Header() {
  const [postContent, setPostContent] = useState("");
  const [mediaFile, setMediaFile] = useState(null);
  const [previewURL, setPreviewURL] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [isOptionOpen, setOptionOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [showDateTimeModal, setShowDateTimeModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isScoreModalOpen, setIsScoreModalOpen] = useState(false);
  const { createPost } = useContext(PostContext);
  const { user } = useContext(IsAuth);
  const navigate = useNavigate(); // Initialize navigate function

  const handleMediaChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setMediaFile(file);
      const preview = URL.createObjectURL(file);
      setPreviewURL(preview);
    }
  };

  const handlePostSubmit = async (e) => {
    e.preventDefault();
    if (!postContent.trim() && !mediaFile) return;

    const formData = new FormData();
    formData.append("content", postContent);
    if (mediaFile) formData.append("media", mediaFile);

    try {
      setLoading(true);
      await createPost(formData);
      setPostContent("");
      setMediaFile(null);
      setPreviewURL("");
      setSelectedOption("");
    } catch (error) {
      console.error("Error creating post:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOptionClick = (option) => {
    if (option === selectedOption) {
      setOptionOpen(false);
    } else {
      setSelectedOption(option);
      setOptionOpen(true);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        event.target.closest(`.${styles.dropdownWrapper}`) === null &&
        event.target.closest(`.${styles.actionButton}`) === null
      ) {
        setOptionOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleShowDateTimeModal = () => {
    setShowDateTimeModal(!showDateTimeModal);
  };
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setShowDateTimeModal(false);
  };
  const handleOpenScoreModal = () => setIsScoreModalOpen(true);
  const handleCloseScoreModal = () => setIsScoreModalOpen(false);
  const handleLiveScoreClick = () => {
    localStorage.setItem("score", "Football");
    navigate("/search");
  };
  
  return (
    <>
      <header className={styles.header}>
        {isLoading && (
          <div className={styles.loadingOverlay}>
            <div className={styles.spinner}></div>
          </div>
        )}
        <div className={styles.postForm}>
          <img
            src={user ? user.avatar : ""}
            alt="User avatar"
            className={styles.userAvatar}
          />
          <div className={styles.inputWrapper}>
            <textarea
              className={styles.postInput}
              placeholder="Game face on! What's on your mind?"
              value={postContent}
              onChange={(e) => setPostContent(e.target.value)}
              aria-label="Create a new post"
            />

            {previewURL && (
              <div className={styles.mediaPreview}>
                <img
                  src={previewURL}
                  alt="Upload preview"
                  className={styles.previewImage}
                />
                <button
                  type="button"
                  className={styles.removeMedia}
                  onClick={() => {
                    setMediaFile(null);
                    setPreviewURL("");
                  }}
                >
                  ×
                </button>
              </div>
            )}

            <div className={styles.postActions}>
              <label className={styles.actionButton}>
                <div className={styles.dropdownWrapper}>
                  <div
                    className={styles.dropdown}
                    onClick={() => setOptionOpen(!isOptionOpen)}
                  >
                    <img src={addPhoto} alt="" className={styles.actionIcon} />
                    <span>Post/Reel</span>
                  </div>

                  {isOptionOpen && (
                    <div className={styles.optionsMenu}>
                      <div
                        className={styles.option}
                        onClick={() => handleOptionClick("post")}
                      >
                        Post
                      </div>
                      <div
                        className={styles.option}
                        onClick={() => handleOptionClick("reel")}
                      >
                        Reel
                      </div>
                    </div>
                  )}
                  {selectedOption === "post" && (
                    <input
                      type="file"
                      accept="image/*,video/*"
                      onChange={handleMediaChange}
                      style={{ display: "none" }}
                    />
                  )}
                </div>
              </label>

              <button
                type="button"
                className={styles.actionButton}
                onClick={handleOpenModal}
              >
                <span
                  className={styles.actionIcon}
                  role="img"
                  aria-label="Basketball"
                  style={{ fontSize: "16px" }}
                >
                  🏀
                </span>
                <span>Set Match</span>
              </button>
              <ChallengeModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                handleShowDateModal={handleShowDateTimeModal}
                showDateTimeModal={showDateTimeModal}
              />
              <button
                type="button"
                className={styles.actionButton}
                onClick={handleOpenScoreModal}
              >
                <img src={addScore} alt="" className={styles.actionIcon} />
                <span>Add Score</span>
              </button>
              <ScoreModal
                isOpen={isScoreModalOpen}
                onClose={handleCloseScoreModal}
                handleShowDateModal={handleShowDateTimeModal}
                showDateTimeModal={showDateTimeModal}
              />

              {/* Live Score Button */}
              <button
                type="button"
                id={styles.liveScore}
                className={styles.actionButton}
                onClick={handleLiveScoreClick} // Navigate to /search
              >
                <span
                  className={styles.actionIcon}
                  role="img"
                  aria-label="Live Score"
                  style={{ fontSize: "16px" }}
                >
                  📊
                </span>
                <span>Live Score</span>
              </button>
            </div>

            <button
              type="submit"
              className={styles.postButton}
              disabled={(!postContent.trim() && !mediaFile) || isLoading}
              onClick={handlePostSubmit}
            >
              {isLoading ? "Posting..." : "Post"}
            </button>
          </div>
        </div>
      </header>

      {selectedOption === "reel" && <CreateReelBox />}
    </>
  );
}

export default Header;
